/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export const Tracking = (): React.JSX.Element | null => {
	let trackingUrl;
	const trackingEnabled = Boolean(
		(!process.env.NEXT_PUBLIC_TRACKING_DISABLED || process.env.NEXT_PUBLIC_TRACKING_DISABLED === "false") &&
		process.env.NEXT_PUBLIC_TRACKING_BASE,
	);
	if (trackingEnabled) {
		trackingUrl = `${process.env.NEXT_PUBLIC_TRACKING_BASE}/tracking.js`;
		// root._epicEnableCookieGuard = true;
		// root.__tracking_base = process.env.NEXT_PUBLIC_TRACKING_BASE;
	}

	if (trackingUrl) {
		return <script key="tracking-script" src={trackingUrl} async />;
	}

	return null;
};
